import { AbilityBuilder, Ability } from '@casl/ability';

export default function defineAbilityFor(user) {
  const { can, cannot, build } = new AbilityBuilder(Ability);

  if (user.roles?.includes('Super Admin')) {
    can('manage', 'all');
  } else {
    let matched = false;

    user.roles?.forEach((role) => {
      switch (role) {
        case 'Admin':
          can('manage', 'all');
          cannot('manage', ['Logs', 'API']);
          matched = true;
          break;
        case 'Techs':
          can('manage', ['Listings', 'Items', 'Tech Support', 'Sales', 'Customer Service', 'Fuse']);
          matched = true;
          break;
        case 'Tech Support':
          matched = true;
          break;
        case 'Customer Service':
          can('manage', ['Listings', 'Items', 'Tech Support', 'Sales', 'Customer Service']);
          matched = true;
          break;
        case 'TV Operations':
          can('manage', ['TVsBrowse', 'TVs', 'TVsInduct']);
          matched = true;
          break;
        case 'Receiving':
          can('manage', ['Sourcing']);
          matched = true;
          break;
        case 'Part Entry':
          can('manage', ['Listings', 'Items', 'Sales', 'Sourcing']);
          matched = true;
          break;
        case 'Teardown':
          can('manage', ['TVs', 'TVsTeardown']);
          matched = true;
          break;
        case 'Returns':
          can('manage', ['Sales', 'Items', 'Listings']);
          can('see', 'Customer Service');
          matched = true;
          break;
        default:
          break;
      }
    });

    // only apply guest/default if nothing matched
    if (!matched) {
      cannot('manage', 'all');
    }
  }

  return build();
}
